import Vue from "vue";
import { search } from "./search";

const livesearchresults = Vue.component("livesearchresults", {
    template: 
    `<div class="livesearchresults">
        <div class="container">
            
            <div v-if="(!results.page.items.length && !results.post.items.length)" class="no-results row">Ei hakua vastaavia tuloksia. Kokeile uudelleen toisella hakusanalla.</div>
            
            <div class="type row" v-for="(item, index) in results" :key="index" v-show="item.items.length">
                <div class="col-12">
                    <h3 class="result-type">{{item.title}}</h3>
                </div>

                <div class="col-md-4" :class="[post.type == 'post' ? 'post-holder' : 'page-holder']" v-for="post in item.items" :key="post.id">
                    <a :href="post.link" class="result" :class="[post.type != 'page' ? ['card', 'card-result']: 'page']">
                        <div class="result-content">
                            <p class="result-terms" v-if="post.type == 'post'">
                                <span class="term category" v-for="category in post.categories">{{category}}</span>
                                <span class="term topic" v-for="aihe in post.aiheet">{{aihe}}</span>
                            </p>
                            <h4 class="result-title">{{post.title}}</h4>
                            <p class="result-excerpt" v-if="post.type == 'page'" v-html="post.excerpt"></p>
                            <p class="result-meta" v-if="post.type == 'post'">
                                <span class="author" v-if="post.author">{{post.author}} -</span>
                                <span class="date" v-if="post.date">{{post.date}}</span>
                            </p>
                        </div>
                    </a>
                </div>
                <div class="col-12 more-results">
                    <a :href="searchsettings.url" class="cta cta-no-arrow black">{{searchsettings.button_text}}</a>
                </div>
            </div>
        </div>
    </div>`,

    props: ["results", "searchsettings"],

    data: function() {
        return {};
    },
    created: function() {},

    methods: {}
});

export { livesearchresults };
